import React from 'react';

const Proposal = () => {
  // Função para criar o link do WhatsApp
  const createWhatsAppLink = (message) => {
    const phoneNumber = "5537998630380"; // Adicionando o código do país (55) antes do número
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  };

  return (
    <section id="proposta" className="py-20 bg-light-gray">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 relative">
            Minha Proposta
            <span className="absolute bottom-0 left-0 w-24 h-1 bg-accent-red mt-2"></span>
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-primary-white p-8 shadow-lg border-t-4 border-accent-red">
              <h3 className="text-2xl font-semibold mb-4">Sessões Terapêuticas</h3>
              <p className="mb-4">Um processo terapêutico profundo e personalizado, que vai além do alívio de sintomas para abordar as raízes dos padrões emocionais disfuncionais.</p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-accent-red mr-2">•</span>
                  <span>Abordagem integrativa que combina Psicanálise, Análise Comportamental e PNL</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-red mr-2">•</span>
                  <span>Foco na reconstrução da identidade emocional e libertação de padrões inconscientes</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-red mr-2">•</span>
                  <span>Processo estruturado para resultados duradouros</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-primary-white p-8 shadow-lg border-t-4 border-accent-red">
              <h3 className="text-2xl font-semibold mb-4">Comunidade Seu Poder</h3>
              <p className="mb-4">Um espaço de suporte contínuo para quem busca aprofundar sua jornada de transformação emocional em comunidade.</p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-accent-red mr-2">•</span>
                  <span>Conteúdos exclusivos e aprofundados sobre reconstrução emocional</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-red mr-2">•</span>
                  <span>Encontros virtuais para reflexão e compartilhamento de experiências</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-red mr-2">•</span>
                  <span>Ferramentas práticas para aplicação no dia a dia</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row gap-6 justify-center">
            <a 
              href={createWhatsAppLink("Olá, gostaria de agendar uma sessão terapêutica.")} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-primary text-lg px-8 py-4 text-center"
              onClick={(e) => {
                window.open(createWhatsAppLink("Olá, gostaria de agendar uma sessão terapêutica."), '_blank');
              }}
            >
              AGENDAR MINHA SESSÃO
            </a>
            <a 
              href={createWhatsAppLink("Olá, gostaria de saber mais sobre a Comunidade Seu Poder.")} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-secondary text-lg px-8 py-4 text-center"
              onClick={(e) => {
                window.open(createWhatsAppLink("Olá, gostaria de saber mais sobre a Comunidade Seu Poder."), '_blank');
              }}
            >
              ENTRAR NA COMUNIDADE SEU PODER
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Proposal;
